// extracted by mini-css-extract-plugin
export var backupIcon = "_so-1";
export var image = "_so-0";